import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TranslationsForm.html?raw';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import TranslationsFormInput from './TranslationsFormInput/TranslationsFormInput';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import FloatingContainer from '../../Floating/FloatingContainer';
import { Language, LanguagesEnglish, LanguagesGerman, LanguageCode, PitLanguageSuffix, PitLanguageMap, CountryCodeIti, CountryCode2, TranslationResponse } from "./TranslationsFormTypes";

class TranslationsForm extends compose(_WidgetBaseSP) {
    templateString: string = template;

    //TODO: define type for data
    //Can't define type because Object has a variable amount of properties and property names are based on attributeName
    private data: Object;
    private isDirty: boolean = false;

    private attributeName: string;
    private commonLanguages: Array<Language>;
    private optionalLanguages: Array<Language>;
    private mandatoryLanguages: Array<Language>;
    private sourceLanguageCode: Language;

    private mainContainer: HTMLDivElement;
    private optionalLanguagesContainer: HTMLDivElement;
    private translationsFormHeaderBar: HTMLDivElement;
    private translateButtonTableHeader: HTMLDivElement;
    private languageInputTable: HTMLTableElement;
    private translationsInputs: Array<MdsLax<InstanceType<typeof TranslationsFormInput>>> = new Array<MdsLax<InstanceType<typeof TranslationsFormInput>>>();
    private sourceLanguageInput: MdsLax<InstanceType<typeof TranslationsFormInput>>;
    private floatingContainer: MdsLax<InstanceType<typeof FloatingContainer>>;

    private isMultiline: boolean = false;
    private multilineRows: number = 4;

    private isHtmlEdit: boolean = false;


    closeFloatingContainer(clickEvent?: MouseEvent): void {
        this.floatingContainer.close(clickEvent);
        this.emit("close");
    }

    setAttributeName(attributeName: string): void {
        this.attributeName = attributeName;
    }

    setSourceLanguageCode(sourceLanguageCode: Language): void {
        this.translationsInputs.forEach((input) => {
            input.setSourceLanguage(sourceLanguageCode);

            if (input.getLanguageCode() == sourceLanguageCode) {
                this.sourceLanguageInput = input;
            }

        });
        this.sourceLanguageCode = sourceLanguageCode;
    }

    private _setLanguages(languages: Array<Language>): void {
        this.commonLanguages = languages;

        if (this.optionalLanguages?.length) {
            let newArr = [];
            for (let opt of this.optionalLanguages) {
                if (this.commonLanguages.indexOf(opt) == -1) newArr.push(opt);
            }

            this.optionalLanguages = newArr;
        }
    }

    getDataForEntity(): Object {
        let multilangObject = {};
        multilangObject[this.attributeName] = lang.clone(this.data);

        return {
            entity: { __multilang: multilangObject },
            targetAttribute: this.attributeName
        };
    }

    getData(): Object {
        return lang.clone(this.data);
    }

    //translateMissingValues(sourceLanguage?: Language) {

    //}

    getValueOfLanguage(language: Language): string {
        for (let input of this.translationsInputs) {
            if (input.getLanguageCode() == language) {
                return input.getValue();
            }
        }

        return null;
    }

    setOptionalLanguages(languages: Array<Language>) {
        this.optionalLanguages = lang.clone(languages);
    }
    setMandatoryLanguages(languages: Array<Language>) {

        let langArray: Array<Language> = [];
        if (languages?.length) {
            for (let language of languages) {
                // es ist noch garnichts erzeugt worden. erst mal alles merken:
                langArray.push(language);
            }
        }

        this.mandatoryLanguages = langArray;

        for (let input of this.translationsInputs) {
            if (this.mandatoryLanguages?.length && this.mandatoryLanguages.indexOf(input.getLanguageCode()) != -1) {
                input.setMandatory(true);
                this.displayOptionalLanguage(input.getLanguageCode())
            } else {
                input.setMandatory(false);
            }
        }
    }

    setMultiline(bMultiline: boolean = true, rows?: number) {
        this.isMultiline = bMultiline !== false;
        if (rows) this.multilineRows = rows;

        if (this.translationsInputs?.length) {
            for (let input of this.translationsInputs) {
                input.setMultiline(this.isMultiline, this.multilineRows);
            }
        }
    }

    setIsHtmlEdit(bHtmlEdit: boolean = true) {
        this.isHtmlEdit = bHtmlEdit;
        if (this.translationsInputs?.length) {
            for (let input of this.translationsInputs) {
                if( input.setIsHtmlEdit) input.setIsHtmlEdit(this.isHtmlEdit);
            }
        }
    }

    /**
     *
     * @param title
     * @param languages
     * @param attributeName
     * @param data
     * @param e Wird benötigt für den FloatingContainer. Ohne das Event muss die Form manuell platziert werden!
     */
    setupForm(title: string, languages: Array<Language>, attributeName: string, data: Object, e?: MouseEvent): void {
        if (!this.optionalLanguages?.length) this.setOptionalLanguages(languages);
        this._setLanguages(languages);
        this.setAttributeName(attributeName);
        this._setTitle(title);
        this.setSourceLanguageCode(window.currentLanguageCode as Language);

        this.data = lang.clone(data);

        this._createInputs();

        if (this.mandatoryLanguages) this.setMandatoryLanguages(this.mandatoryLanguages);

        if (e) {
            this._setupFloatingContainer(e);
        }
    }

    private _setTitle(title: string): void {
        //this.translationsFormHeaderBar.innerHTML = `<i><b>${title}</i></b> ${this.translate("TranslationsForm___Translations")}`;
        this.translationsFormHeaderBar.innerHTML = title;
    }

    private _setupFloatingContainer(clickEvent: Event): void {
        this.floatingContainer = new FloatingContainer();
        this.floatingContainer.open(clickEvent, this.domNode, true);
        this.emit("open");
    }

    private _createInputs(): void {
        let allLanguages: Array<Language> = this.commonLanguages;

        if (this.optionalLanguages?.length) allLanguages = allLanguages.concat(this.optionalLanguages);

        allLanguages.forEach((language) => {

            var currentInput = this._createLanguageInput(language);
            if (currentInput.getLanguageCode() === this.sourceLanguageCode) {
                this.sourceLanguageInput = currentInput;
            }

            this._setInputData(language, currentInput, true);

            if (this.optionalLanguages?.indexOf(language) != -1) {
                this.hideNode(currentInput);
            }


        });

        this._createOptionalLanguageSelectors();

        if (!allLanguages.length) {
            this.UiModder.domConstruct.create("p", { className: "warningBG", "innerHTML": "no languages set!" }, this.mainContainer);
        }
    }

    private _createOptionalLanguageSelectors() {
        this.UiModder.domConstruct.empty(this.optionalLanguagesContainer);
        this.hideNode(this.optionalLanguagesContainer, !this.optionalLanguages?.length);

        for (let language of this.optionalLanguages) {
            // falls ein Wert in den Daten vorhanden ist, dann gleich anzeigen lassen!
            let suffix = this.getPitSuffixFromLanguage(language);
            if (this.data && this.data[suffix]) {
                this.displayOptionalLanguage(language);
            } else {
                let button = this.UiModder.domConstruct.create("button", {
                    className: "mds-button-base padding flex_row_center tertiaryBG hoverDark roundest optionalLanguage" + " optional_" + language,
                    innerHTML: this.createFontawesomeIcon("fas fa-plus", "&nbsp;").outerHTML
                }, this.optionalLanguagesContainer);

                var targetLanguageClass = `iti__${CountryCodeIti[language]}`;


                this.UiModder.domConstruct.create("span", {
                    className: "iti__flag center " + targetLanguageClass
                }, button);

                on(button, "click", lang.hitch(this, this.displayOptionalLanguage, language));
            }

        }


    }

    private displayOptionalLanguage(language: Language) {
        let buttons = this.optionalLanguagesContainer.getElementsByClassName("optional_" + language);
        for (let i = 0; i < buttons.length; i++) {
            this.UiModder.domConstruct.destroy(buttons[i]);
        }

        for (let input of this.translationsInputs) {
            if (input.getLanguageCode() == language) {
                this.hideNode(input, false);
                break;
            }
        }
    }

    private _setInputData(language: Language, input: MdsLax<InstanceType<typeof TranslationsFormInput>>, suppressChangeEvent?: boolean): void {
        var dataPath = this.getPitSuffixFromLanguage(language);
        if (this.data && this.data[dataPath]) {
            input.setValue(this.data[dataPath], suppressChangeEvent);
        }
    }

    private _createLanguageInput(language: Language): MdsLax<InstanceType<typeof TranslationsFormInput>> {
        let translationsInput = new TranslationsFormInput();

        this.translationsInputs.push(translationsInput);
        translationsInput.setLanguage(language, this.sourceLanguageCode);

        if (this.optionalLanguages.indexOf(language) != -1) {
            this.UiModder.domClass.add(translationsInput.domNode, "optionalLanguage");
        }

        if (this.mandatoryLanguages?.length && this.mandatoryLanguages.indexOf(language) != -1) translationsInput.setMandatory();

        translationsInput.on("requestTranslation", lang.hitch(this, this._onClickTranslate));
        translationsInput.on("change", lang.hitch(this, this._onInputChange));

        if (this.isMultiline) {
            translationsInput.setMultiline(this.isMultiline, this.multilineRows);
        }


        if (this.isHtmlEdit) {
            if(translationsInput.setIsHtmlEdit) translationsInput.setIsHtmlEdit(this.isHtmlEdit);
        }

        let checkBox = translationsInput.sourceLanguageCheckbox;
        checkBox.on("change", lang.hitch(this, this._onSourceLanguageCheckboxChange, language, translationsInput))
        translationsInput.placeAt(this.languageInputTable);

        return translationsInput;
    }

    private _onSourceLanguageCheckboxChange(languageCode: LanguageCode, input: MdsLax<InstanceType<typeof TranslationsFormInput>>, state: boolean): void {
        if (state && languageCode !== this.sourceLanguageCode) {
            this.setSourceLanguageCode(languageCode);
        } else if (!state && languageCode === this.sourceLanguageCode) {
            input.sourceLanguageCheckbox.setChecked(true, true);
        }
    }

    private _onClickTranslate(inputRow: MdsLax<InstanceType<typeof TranslationsFormInput>>): void {
        let suffix = this.getPitSuffixFromLanguage(this.sourceLanguageCode);
        if (!suffix) return;

        if (this.data[suffix] && this.data[suffix].length > 0) {
            // ok - Inhalt vorhanden
            //Show warning toast if source text is empty to prevent data deletion
        } else {
            // kein Inhalt vorhanden - User warnen mit Toast
            this.sourceLanguageInput.setDangerStyle(true);
            this.showToast({
                title: this.translate("TranslationsForm___EmptySourceTextError"),
                iconClass: toasterIcons.warning
            });
        }

        this.fetchTranslation(this.sourceLanguageCode, this.sourceLanguageInput.getValue(), inputRow.getLanguageCode(), lang.hitch(this, this._onTranslateInput, inputRow));
    }

    private _onTranslateInput(inputRow: MdsLax<InstanceType<typeof TranslationsFormInput>>, value: string) {
        inputRow.setValue(value);
    }

    private fetchTranslation(sourceLanguage: Language, text: string, targetLanguage: Language, callback: (value: string) => void): void {
        var sourceLanguageCode2: CountryCode2 = CountryCode2[sourceLanguage];
        var targetLanguageCode2 = CountryCode2[targetLanguage];


        let requestData = {
            sourceLang: sourceLanguageCode2,
            targetLang: targetLanguageCode2,
            text: encodeURI(text),
            tagHandling: this.isHtmlEdit ? "html" : null
        };

        this.RequestManager.callfunction(
            "Webtool_API_DeepL__GetTranslation",
            requestData,
            lang.hitch(this, this._onTranslationResponse, callback),
            lang.hitch(this, this._onTranslationError)
        );

        // alter Aufruf direkt via Controller ohne pit-API:

        //console.log(this.isHtmlEdit, requestString);
        //text = encodeURIComponent(text);
        //if (this.isHtmlEdit) {

        //    var requestString =
        //        `${window.appRoot}WebTranslations/GetLiveTranslation?sourceLang=${sourceLanguageCode2}&targetLang=${targetLanguageCode2}&tagHandling=html&text=${text}`;
        //} else {
        //    var requestString =
        //        `${window.appRoot}WebTranslations/GetLiveTranslation?sourceLang=${sourceLanguageCode2}&targetLang=${targetLanguageCode2}&text=${text}`;
        //}

    //    this.RequestManager.get(requestString,
    //        lang.hitch(this, this._onTranslationResponse, callback),
    //        lang.hitch(this, this._onTranslationError));
    }

    private _onTranslationResponse(callback: (translatedValue: string) => void, response: TranslationResponse): void {
        if (response?.translations?.length) {
            callback(decodeURI(response.translations[0].text));
            //this.textInput.setValue(response.translations[0].text);
        } else if (response.translationResult) { // neu ab 2025-05, wenn Aufruf via API
            callback(decodeURI(response.translationResult));
        }

        this.removeToast(this.id);
    }

    private _onTranslationError(error: more.requestErrorMessage): void {
        console.error(error);

        this.showToast({
            title: "translation failed",
            iconClass: toasterIcons.error,
            ID: this.id,
            message: error.Message
        });
    }


    private _onClickCancel(e: MouseEvent): void {
        e.stopPropagation();
        this.closeFloatingContainer(e);
    }

    private _onClickOk(e: MouseEvent): void {
        e.stopPropagation();
        this.closeFloatingContainer(e);


        this.emit("ok");
    }

    getPitSuffixFromLanguage(language: Language): PitLanguageSuffix {
        if (!language) return null;

        for (let entry in PitLanguageMap) {
            if (PitLanguageMap[entry] == language) {
                return entry as any;
            }
        }

        return null;
    }

    getLanguageFromPitSuffix(pitlanguage: PitLanguageSuffix): Language {
        if (!pitlanguage) return null;

        return PitLanguageMap[pitlanguage];


    }

    private _onInputChange(input: MdsLax<InstanceType<typeof TranslationsFormInput>>): void {
        var dataPath = this.getPitSuffixFromLanguage(input.getLanguageCode());
        this.changeData(dataPath, input.getValue());

        if (input.getLanguageCode() === window.currentLanguageCode) {
            this.changeData("current", input.getValue());
        }

        //remove danger style if the source language input is changed
        if (input === this.sourceLanguageInput) {
            this.sourceLanguageInput.setDangerStyle(false);
        }
    }

    private changeData(dataPath: string, newData: string): void {
        if (typeof this.data != 'undefined'){
            if (this.data[dataPath] !== newData) {
                this.data[dataPath] = newData;
                this._setIsDirty(true);
            }
        }
    }

    private _setIsDirty(isDirty: boolean): void {
        this.isDirty = isDirty;
    }

    private _onKeyUp_Dlg(evt: any): void {

        if (evt.keyCode == 13 && this.isMultiline != true) {
            this._onClickOk(evt);
        }
        if (evt.keyCode == 27) {
            this._onClickCancel(evt);
        }
    }

    getIsDirty(): boolean {
        return this.isDirty;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        if (!this.hasFeature("Multilang/EnableTranslation")) {
            this.hideNode(this.translateButtonTableHeader, true);
        }


        this.mandatoryLanguages = [];
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

}

export default mdsWidget(TranslationsForm);
